import { Box } from "@mui/material"
import useStyles from "../styles"
import BaseAppBar from "@/components/base/app-bar"
import { EditContainerProps } from "@/types/page"
import { DrawerBloc } from "@/components/widget/drawer-bloc"

const EditModelContainer = ({ children, onClose, open }: EditContainerProps) => {
    const { classes } = useStyles()

    return (
        <DrawerBloc
            disableScrollLock
            hideBackdrop
            anchor={"right"}
            open={open}
            onClose={onClose}
            transitionDuration={600}
            disableEscapeKeyDown
            classPaper={classes.containerDrawer}
        >
            <BaseAppBar />
            <Box className="children-wrapper" data-testid="bloc-children">
                {children}
            </Box>
        </DrawerBloc>
    )
}

export default EditModelContainer
